module.exports = __webpack_public_path__ + "img/Button_AppStoreEnabled-smv.2269e39b.png";